// DelayedFallback.tsx
import { useEffect, useState } from 'react';

interface DelayedFallbackProps {
	delay: number; // in ms
	fallback: React.ReactNode;
}

export const DelayedFallback: React.FC<DelayedFallbackProps> = ({
	delay,
	fallback,
}) => {
	const [showFallback, setShowFallback] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => setShowFallback(true), delay);
		return () => clearTimeout(timer); // cleanup on unmount
	}, [delay]);

	return showFallback ? <>{fallback}</> : null;
};
